import flatMap from 'lodash/flatMap';
import { getMcpApps } from '../Services/config';
import find from 'lodash.find';

const camelize = str => {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
      return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
    })
    .replace(/\s+/g, '');
};

export const getUserRecentLogins = accessToken =>
  getMcpApps().then(mcpApps => {
    return fetch('https://marketplace-service.mex.cimpress.io/v1/user/logins', {
      method: 'GET',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      }),
    }).then(response => {
      return response.json().then(logins => {
        const loginList = Object.keys(logins).map(clientId => ({ clientId, count: logins[clientId] }));
        if (!loginList.length) {
          return null;
        }

        return loginList
          .map(({ clientId, count }) => ({
            clientId,
            count,
            ...(find(mcpApps, mcpApp => mcpApp.clientId === clientId) || {}),
          }))
          .filter(login => login.link && login.id)
          .sort((a, b) => b.count - a.count);
      });
    });
  });
